/* Hellas Natura — Kosmetik JS */
/* Drag-to-scroll + Ticker/Marquee */

(function () {
  'use strict';

  /* ─── Drag-to-scroll ──────────────────────────────── */

  function initDragScroll(el) {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    el.addEventListener('mousedown', function (e) {
      isDown = true;
      el.classList.add('is-dragging');
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    });

    el.addEventListener('mouseleave', function () {
      isDown = false;
      el.classList.remove('is-dragging');
    });

    el.addEventListener('mouseup', function () {
      isDown = false;
      el.classList.remove('is-dragging');
    });

    el.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - el.offsetLeft;
      var walk = (x - startX) * 1.5;
      el.scrollLeft = scrollLeft - walk;
    });

    /* Touch */
    var touchStartX = 0;
    var touchScrollLeft = 0;

    el.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].pageX - el.offsetLeft;
      touchScrollLeft = el.scrollLeft;
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      var x = e.touches[0].pageX - el.offsetLeft;
      var walk = (x - touchStartX) * 1.5;
      el.scrollLeft = touchScrollLeft - walk;
    }, { passive: true });
  }

  function initAllDragScroll() {
    document.querySelectorAll('.hn-scroll-container').forEach(initDragScroll);
  }

  /* ─── Ticker / Marquee ────────────────────────────── */

  function initTicker(el) {
    var inner = el.querySelector('.hn-ticker__inner');
    if (!inner) return;

    /* Dupliziere Inhalt für nahtlose Endlosschleife */
    var original = inner.innerHTML;
    inner.innerHTML = original + original;

    /* Passe Animationsdauer an Inhalt-Breite an */
    function updateDuration() {
      var totalWidth = inner.scrollWidth;
      var halfWidth = totalWidth / 2;
      var speed = 60; /* px/s */
      var duration = halfWidth / speed;
      inner.style.animationDuration = duration.toFixed(2) + 's';
    }

    updateDuration();
    window.addEventListener('resize', updateDuration, { passive: true });
  }

  function initAllTickers() {
    document.querySelectorAll('.hn-ticker').forEach(initTicker);
  }

  /* ─── Intersection Observer für Scroll-Animationen ── */

  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hn-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('[data-hn-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ─── Init ────────────────────────────────────────── */

  function init() {
    initAllDragScroll();
    initAllTickers();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify Section-Reload im Theme-Editor */
  document.addEventListener('shopify:section:load', function () {
    initAllDragScroll();
    initAllTickers();
    initScrollReveal();
  });
})();
